import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
  /** Sortable id — must match the id passed to the enclosing SortableContext */
  id: string
  isDndEnabled?: boolean
}>

const CommentInListDndComponent = ({
  children,
  id,
  isDndEnabled = true,
}: Props) => {
  const {
    setNodeRef,
    transform,
    transition,
    isDragging,
    isSorting,
    attributes,
    listeners,
  } = useSortable({ id, disabled: !isDndEnabled })

  const style: React.CSSProperties = isSorting
    ? {
        transform: `translateY(${transform?.y ?? 0}px)`,
        transition,
        position: 'relative',
        zIndex: isDragging ? 1 : undefined,
        opacity: isDragging ? 0.5 : 0.999,
        cursor: isDragging ? 'grabbing' : 'grab',
      }
    : { cursor: isDndEnabled ? 'grab' : 'default' }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...(isDndEnabled ? { ...attributes, ...listeners } : {})}
    >
      {children}
    </div>
  )
}

export default CommentInListDndComponent
